import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, TextField, Chip, Checkbox } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import nameStringFn from "../../../data/nameStringFn";
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import { useGetdesignationsQuery } from '../../../features/designations/designationApiSlice';
import DetailsIcon from '@mui/icons-material/Details';
// import UserdetailsModal from './UserdetailsModal';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useGetofficesQuery } from '../../../features/offices/officesApiSlice';
import useAuth from '../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ExcelDownload from '../../../data/exceldownload';
import { useGetAssetsFinalQuery } from '../../../features/addassets/addassetfinalApiSlice';
import { useGetconsumfinalQuery } from '../../../features/consumfinal/consumfinalApiSlice';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {DatePicker} from "@mui/x-date-pickers";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import MyConsumModal from './MyConsumModal';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Button2Div =styled.div`
  display: flex;
  justify-content: end;

`
const Wrapper = styled.div`
    display: flex;
    background-color: white;
    align-items:center;
    /* width: 100; */
`
const SpanContainer = styled.div`
  display: flex;
  justify-content:flex-end;
  margin-right:5px;
  `
const StatusSpan = styled.span`
  font-size:16px;
  font-family:Arial, sans-serif;
  font-weight:bold;
  color:#333;  
`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 15;

// The user Roles Array function creates an array of all roles so that they can be displayed as chips in the table.
const userRolesArray = (userObject) => {
  if (!userObject?.roles) return [];
  
  const mainRoleArray = userObject?.roles?.main || [];
  let officeRoleArray = [];
  
  for(let key in userObject?.roles){
    if(key !== "main" && userObject?.roles[key]){
      for(let val of userObject?.roles[key]){
        if (val) officeRoleArray.push(`${val} (${key})`)
      }
    }
  }
  
  return mainRoleArray.concat(officeRoleArray);
}


//The findSubordinateOffices function gives an array of objects of all offices which are subordinate to officeName.
const findSubordinateOffices = (offices, officeName, result = []) => {
  const subOffices = offices? offices?.filter(office => office?.superioroffice === officeName):[];
  for (const subOffice of subOffices) {
    result.push(subOffice);
    findSubordinateOffices(offices, subOffice?.name, result);
  }
  return result;
}

//The filterFunctionUser gives the array of filtered array of users as per roles available.
const filterFunctionUser =  (userArray, Auth, presentOffice, officeArray ) =>{
  let tempArray = structuredClone(userArray);
  const rolesArray = Auth.roles[presentOffice];
  if(Auth.roles["main"].includes("Admin") || rolesArray.some(item => ["level1approver", "level2approver"].includes(item)) ){
    return userArray;
  }
  if(rolesArray.includes("Bo") && !rolesArray.includes("UnitHead")){
    tempArray = tempArray.filter(x => Object.values(x.office).flat(3).includes(presentOffice))
    return tempArray
  }
  if(rolesArray.includes("UnitHead")){
    const subordinateOffices = findSubordinateOffices(officeArray, presentOffice).map(x=> x.name)
    tempArray = tempArray.filter(x => Object.values(x.office).flat(3).some(item => subordinateOffices.concat(presentOffice).includes(item)));
    return tempArray
  }
}

//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B)=> {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}

export default function UnivMyAssetComp({keyArrayDwld, finalData, columnFilter, asstCounter, setAsstCounter}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [consumDetailmodalopen, setConsumDetailmodalopen] = useState(false);
  const [consumDetailModaldata, setConsumDetailModaldata] = useState({});
  const [downloadData, setDownloadData] = useState({});
  const [tempTableData, setTempTableData] = useState([]);
  const [tabledata, setTabledata]= useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const Auth = useAuth();
  const presentOffice = useSelector(state => state.office.off)


  const [searchData, setSearchData] = useState({
    consumable:"",
    category:"",
    partno:"",
    orderno:"",
    cur_store:"",
    order_quantity_from:"",
    order_quantity_to:"",
    balance_quantity_from:"",
    balance_quantity_to:"",
    transit_quantity_from:"",
    transit_quantity_to:"",
    purchase_date_from:null,
    purchase_date_to:null
  }); 


  const {users} =  useGetUsersQuery("UserList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })
  //get single assets
  const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      getSingleasset: data?.entities
    }),
  })
  const {designations} = useGetdesignationsQuery("DesigList", {
    selectFromResult: ({ data }) => ({
      designations: data?.entities
    }),
  })

  const {offices} = useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })

  // Get consumable final data for real-time balance quantities
  // Pass empty object to get all consumablefinal records
  const {consumablefinal, isLoading: consumablefinalLoading} = useGetconsumfinalQuery({}, {
    selectFromResult: ({ data, isLoading }) => ({
      consumablefinal: data?.entities, // Now properly using entity adapter
      isLoading
    }),
  })

  // Helper function to get balance quantity for a consumable+partno+store combination
  const getBalanceQuantity = (consumable, partno, store) => {
    if (!consumablefinal) return 0;
    
    // Find the matching consumablefinal entry
    const finalEntry = Object.values(consumablefinal).find(item => 
      item.consumable === consumable && 
      item.partno === partno && 
      item.store === store
    );
    
    return finalEntry ? (finalEntry.balance_order_quantity || 0) : 0;
  };

  // Helper function to get transit quantity for a consumable+partno+store combination
  const getTransitQuantity = (consumable, partno, store) => {
    if (!consumablefinal) return 0;
    
    // Find the matching consumablefinal entry
    const finalEntry = Object.values(consumablefinal).find(item => 
      item.consumable === consumable && 
      item.partno === partno && 
      item.store === store
    );
    
    return finalEntry ? (finalEntry.intransit_order_quantity || 0) : 0;
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleConsumDetailModalClose = () => {
    setConsumDetailmodalopen(false);
  };

  const handleDetailsClick = (e, row)  => {
    setConsumDetailModaldata(row);
    setConsumDetailmodalopen(true)
  };  
  
  const handleSearchChange = (event, newValue, name) =>{
    let tempData = structuredClone(tempTableData);
    let tempSearchData = structuredClone(searchData);
    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
     }else if (event.$d){
      if(name === "purchase_date_from" && tempSearchData["purchase_date_to"]?.length && event.$d > new Date(tempSearchData["purchase_date_to"]) ){
          alert(`"From" Purchase Date cannot be after "To" Purchase Date`);
          return;
      }
      if(name === "purchase_date_to" && tempSearchData["purchase_date_from"]?.length && event.$d < new Date(tempSearchData["purchase_date_from"])){
        alert(`"From" Purchase Date cannot be after "To" Purchase Date`);
        return;
      }
      tempSearchData[name]= event.$d;
     }else{
      tempSearchData[name] = newValue;
     }
    setSearchData(tempSearchData);
     for(let key in tempSearchData){
      if( ["orderno","category","consumable", "cur_store", "partno"].includes(key) && tempSearchData[key].length){
        tempData = tempData.filter(x=> x[key]?.toLowerCase().includes(tempSearchData[key]?.toLowerCase()))          
      }
      
      // Order Quantity range filter
      if(key === "order_quantity_from" && tempSearchData[key].length){
        const fromValue = parseInt(tempSearchData[key]);
        if (!isNaN(fromValue)) {
          tempData = tempData.filter(x=> parseInt(x.order_quantity) >= fromValue)
        }
      }
      if(key === "order_quantity_to" && tempSearchData[key].length){
        const toValue = parseInt(tempSearchData[key]);
        if (!isNaN(toValue)) {
          tempData = tempData.filter(x=> parseInt(x.order_quantity) <= toValue)
        }
      }
      
      // Balance Quantity range filter
      if(key === "balance_quantity_from" && tempSearchData[key].length){
        const fromValue = parseInt(tempSearchData[key]);
        if (!isNaN(fromValue)) {
          tempData = tempData.filter(x=> {
            const balanceQty = getBalanceQuantity(x.consumable, x.partno, x.cur_store);
            return balanceQty >= fromValue;
          })
        }
      }
      if(key === "balance_quantity_to" && tempSearchData[key].length){
        const toValue = parseInt(tempSearchData[key]);
        if (!isNaN(toValue)) {
          tempData = tempData.filter(x=> {
            const balanceQty = getBalanceQuantity(x.consumable, x.partno, x.cur_store);
            return balanceQty <= toValue;
          })
        }
      }
      
      // Transit Quantity range filter
      if(key === "transit_quantity_from" && tempSearchData[key].length){
        const fromValue = parseInt(tempSearchData[key]);
        if (!isNaN(fromValue)) {
          tempData = tempData.filter(x=> {
            const transitQty = getTransitQuantity(x.consumable, x.partno, x.cur_store);
            return transitQty >= fromValue;
          })
        }
      }
      if(key === "transit_quantity_to" && tempSearchData[key].length){
        const toValue = parseInt(tempSearchData[key]);
        if (!isNaN(toValue)) {
          tempData = tempData.filter(x=> {
            const transitQty = getTransitQuantity(x.consumable, x.partno, x.cur_store);
            return transitQty <= toValue;
          })
        }
      }
      if( (key === "oem_tag") && tempSearchData[key].length){
        tempData = tempData.filter(x=> `${x["oem_tag"]?.toLowerCase()} ${x["org_tag"]?.toLowerCase()}`.includes(tempSearchData[key]?.toLowerCase()))          
      }
      if(key === "user" && tempSearchData[key].length){
        tempData = tempData.filter(x=>`${users[x?.alloc_user]?.email} (${nameStringFn(users[x?.alloc_user])})`.toLowerCase().includes(tempSearchData[key].toLowerCase()))
      }
      if(key === "store" && tempSearchData[key].length){
        tempData = tempData.filter(x=> tempSearchData[key].includes(x["cur_store"]))          
      }
      // if(key === "location" && tempSearchData[key].length){        
      //   tempData = tempData.filter(x=> tempSearchData[key].includes(x[key]))
      // }
      if(key === "specification" && tempSearchData[key].length){
        tempData = tempData.filter(x =>  Object.entries(x?.specification).map(elm => `${elm[0]}: ${elm[1]}`).some(item => item?.toLowerCase().includes(tempSearchData[key]?.toLowerCase())))
      }
      if(key === "purchase_date_from" ){ 
        if(tempSearchData[key]?.toISOString()?.length) tempData = tempData.filter(x => (tempSearchData["purchase_date_from"] <= new Date(x["purchase_date"])))
        if(event?.type === "click"){
          tempSearchData["purchase_date_to"] = null;
          setSearchData(tempSearchData)
        }
      }
      if(key === "purchase_date_to" && tempSearchData[key]?.toISOString()?.length  ){
        tempData = tempData.filter(x => (tempSearchData["purchase_date_to"] >= new Date(x["purchase_date"])))
      }
    }
    setTabledata(tempData.sort((a,b) => b.name - a.name));
  }

useEffect(()=>{
  if(finalData){    
    setTempTableData(finalData)
    setTabledata(finalData)
  }  
},[finalData])


//Setting the download data for excel download.
useEffect(()=>{
  if(keyArrayDwld){
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others,  ["last_trans_date"]:val?.last_trans_date?.length?  moment(val?.last_trans_date).format("DD/MM/YYYY"):"Not Available"}
      finalDownloadData.push(others)
    }

    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyArrayDwld){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
  }
}, [tabledata])


  // Calculate unique balance and transit quantities (one per consumable+partno+store combination)
  const calculateUniqueBalances = () => {
    if (!tabledata?.length) return { orderQty: 0, balanceQty: 0, transitQty: 0 };
    
    // Sum all order quantities (linear sum of all rows)
    const orderQty = tabledata.reduce((acc, doc) => acc + (parseInt(doc.order_quantity) || 0), 0);
    
    // For balance and transit quantities, count each unique combination only once
    const uniqueCombinations = new Map();
    tabledata.forEach(doc => {
      const key = `${doc.consumable}|${doc.partno}|${doc.cur_store}`;
      if (!uniqueCombinations.has(key)) {
        const balance = getBalanceQuantity(doc.consumable, doc.partno, doc.cur_store);
        const transit = getTransitQuantity(doc.consumable, doc.partno, doc.cur_store);
        uniqueCombinations.set(key, { balance, transit });
      }
    });
    
    // Sum unique balances and transit quantities
    const balanceQty = Array.from(uniqueCombinations.values()).reduce((acc, val) => acc + val.balance, 0);
    const transitQty = Array.from(uniqueCombinations.values()).reduce((acc, val) => acc + val.transit, 0);
    
    return { orderQty, balanceQty, transitQty };
  };
  
  const { orderQty, balanceQty, transitQty } = calculateUniqueBalances();
  
  return (
    <>
      {keyArrayDwld && <Button2Div>
          <ExcelDownload data={downloadData} filename={"assetDetail"} sheetName={"sheet1"}/>
      </Button2Div>}
      <div>
      {((columnFilter.includes("OrderQty") || columnFilter.includes("BalanceQty") || columnFilter.includes("TransitQty")) && tabledata?.length) ? <SpanContainer>
          <StatusSpan>
          {`Total Quantity: ${columnFilter.includes("OrderQty") ? `Order Qt = ${orderQty}` : ''}${(columnFilter.includes("OrderQty") && (columnFilter.includes("BalanceQty") || columnFilter.includes("TransitQty"))) ? ', ' : ''}${columnFilter.includes("BalanceQty") ? `Balance Qty = ${balanceQty}` : ''}${(columnFilter.includes("BalanceQty") && columnFilter.includes("TransitQty")) ? ', ' : ''}${columnFilter.includes("TransitQty") ? `Transit Qty = ${transitQty}` : ''}`}
          </StatusSpan>
      </SpanContainer> : null}
      <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
      <TableHead  style={{backgroundColor: TableHeadStyle.backgroundColor }}>
        <TableRow >          
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"3%"}}} >Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Consumable</TableCell>
          {columnFilter?.includes("Category") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"11%"}}} align="left">Category</TableCell>}
          {columnFilter?.includes("PartNo") && <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}}align="left">Part No.</TableCell>}
          {columnFilter?.includes("OrderNo") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"6%"}}} align="left">Order No.</TableCell>}
          {columnFilter?.includes("Store") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"11%"}}} align="left">Store</TableCell>}
          {columnFilter?.includes("OrderQty") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Order Qty</TableCell>}
          {columnFilter?.includes("BalanceQty") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Balance Qty</TableCell>}
          {columnFilter?.includes("TransitQty") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Transit Qty</TableCell>}
          {columnFilter?.includes("Purchase Date") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"14%"}}} align="left">Purchase Date</TableCell>}
          {columnFilter?.includes("Detail") &&<TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"9%"}}} align="left">Detail</TableCell>}
        </TableRow>

        <TableRow  >

          <TableCell>
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='consumable' onChange={handleSearchChange} label="Search Consumable" size="small"  variant="outlined" />
          </TableCell>

          {columnFilter?.includes("Category") &&<TableCell>
            <TextField sx={{background:"white"}}  name='category' onChange={handleSearchChange} label="Search Category" size="small"  variant="outlined" />
          </TableCell>}

          {columnFilter?.includes("PartNo") &&<TableCell>
            <TextField sx={{background:"white"}}  name='partno' onChange={handleSearchChange} label="Part No" size="small"  variant="outlined" />
          </TableCell>}

          {columnFilter?.includes("OrderNo") &&<TableCell>
            <TextField sx={{background:"white"}}  name='orderno' onChange={handleSearchChange} label="Order No" size="small"  variant="outlined" />
          </TableCell>}

          {columnFilter?.includes("Store") &&<TableCell>
            <TextField sx={{background:"white"}}  name='cur_store' onChange={handleSearchChange} label="Store" size="small"  variant="outlined" />
          </TableCell>}

          {columnFilter?.includes("OrderQty") &&<TableCell>
            <TextField 
              sx={{background:"white", width: '100%'}}  
              name='order_quantity_from' 
              onChange={handleSearchChange} 
              label="From" 
              size="small"  
              type="number"
              variant="outlined" 
              fullWidth
            />
            {searchData?.order_quantity_from && (
              <TextField 
                sx={{background:"white", width: '100%', marginTop: '8px'}}  
                name='order_quantity_to' 
                onChange={handleSearchChange} 
                label="To" 
                size="small"
                type="number"  
                variant="outlined" 
                fullWidth
              />
            )}
          </TableCell>}

          {columnFilter?.includes("BalanceQty") &&<TableCell>
            <TextField 
              sx={{background:"white", width: '100%'}}  
              name='balance_quantity_from' 
              onChange={handleSearchChange} 
              label="From" 
              size="small"
              type="number"  
              variant="outlined" 
              fullWidth
            />
            {searchData?.balance_quantity_from && (
              <TextField 
                sx={{background:"white", width: '100%', marginTop: '8px'}}  
                name='balance_quantity_to' 
                onChange={handleSearchChange} 
                label="To" 
                size="small"
                type="number"  
                variant="outlined" 
                fullWidth
              />
            )}
          </TableCell>}

          {columnFilter?.includes("TransitQty") &&<TableCell>
            <TextField 
              sx={{background:"white", width: '100%'}}  
              name='transit_quantity_from' 
              onChange={handleSearchChange} 
              label="From" 
              size="small"
              type="number"  
              variant="outlined" 
              fullWidth
            />
            {searchData?.transit_quantity_from && (
              <TextField 
                sx={{background:"white", width: '100%', marginTop: '8px'}}  
                name='transit_quantity_to' 
                onChange={handleSearchChange} 
                label="To" 
                size="small"
                type="number"  
                variant="outlined" 
                fullWidth
              />
            )}
          </TableCell>}

          {columnFilter?.includes("Purchase Date") &&<TableCell>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']} sx={{margin:"0px", display:"flex"}} >
              <Wrapper>
              <DatePicker
                label="From"
                maxDate={searchData?.purchase_date_to?.toISOString().length? dayjs(searchData?.purchase_date_to):null}
                slotProps={{ textField: { size: 'small', fullWidth:true } }}
                sx={{backgroundColor:"white"}}
                value={searchData?.purchase_date_from?.toISOString().length? dayjs(searchData?.purchase_date_from):null}
                format="DD/MM/YYYY"
                // required={finalSubClicked}               
                onChange={(event, newValue) => handleSearchChange(event, newValue, 'purchase_date_from')}
              />
              {searchData?.purchase_date_from?.toISOString()?.length &&  <ClearIcon onClick = {(event, newValue)=>handleSearchChange(event, newValue, 'purchase_date_from')} />}
              </Wrapper>
            </DemoContainer>
          </LocalizationProvider>
          {searchData?.purchase_date_from?.toISOString()?.length && <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']} >
            <Wrapper>
              <DatePicker
                label="To"
                minDate={searchData?.purchase_date_from?.toISOString()?.length? dayjs(searchData?.purchase_date_from):null}
                slotProps={{ textField: { size: 'small' } }}
                sx={{backgroundColor:"white"}}
                value={searchData?.purchase_date_to?.toISOString().length? dayjs(searchData?.purchase_date_to):null}
                format="DD/MM/YYYY"
                onChange={(event, newValue) => handleSearchChange(event, newValue, 'purchase_date_to')}
              />
            {searchData?.purchase_date_to?.toISOString().length && <ClearIcon onClick = {(event, newValue)=>handleSearchChange(event, newValue, 'purchase_date_to')} />}
            </Wrapper>
            </DemoContainer>
          </LocalizationProvider>}        
          </TableCell>}

          {columnFilter?.includes("Detail") &&<TableCell>
          </TableCell>}
        </TableRow>
      </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : tabledata
          ).map((row,index) => (            

            <TableRow key={index}>              

              <TableCell component="th" scope="row" align='center' sx={{ fontSize: tableFontSize}}>
              {(page)*(rowsPerPage)+index+1}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.consumable}
              </TableCell>

              {columnFilter.includes("Category") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.category}
              </TableCell>}

              {columnFilter.includes("PartNo") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.partno}
              </TableCell>}

              {columnFilter.includes("OrderNo") &&<TableCell  align="left" sx={{ fontSize: tableFontSize, maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row?.orderno}>
                {row?.orderno}
              </TableCell>}

              {columnFilter.includes("Store") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.cur_store}
              </TableCell>}

              {columnFilter.includes("OrderQty") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.order_quantity}
              </TableCell>}

              {columnFilter.includes("BalanceQty") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {getBalanceQuantity(row?.consumable, row?.partno, row?.cur_store)}
              </TableCell>}

              {columnFilter.includes("TransitQty") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {getTransitQuantity(row?.consumable, row?.partno, row?.cur_store)}
              </TableCell>}

              {columnFilter.includes("Purchase Date") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {moment(row?.purchase_date).format("DD-MM-YYYY")}
              </TableCell>}

              {columnFilter.includes("Detail") &&<TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                <DetailsIcon sx={{color:"green", fontSize:"40px", '&:hover':{"cursor":"pointer"}}} onClick={(e) => handleDetailsClick(e, row)} />
              </TableCell>}              

            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata? tabledata?.length:[]}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>''
    </div>
    
    {consumDetailmodalopen && <MyConsumModal
      consumDetailmodalopen = {consumDetailmodalopen}
      consumDetailModaldata = {consumDetailModaldata}      
      handleConsumDetailModalClose = {handleConsumDetailModalClose}
      users = {users}
    />}
    </>
  );
}